// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Charlotte from "./charlotte"
import SuccessClientSection1 from "./section1"
import { colors } from "../../utils/theme/colors"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import SuccessClientSection3 from "./section3"
import SuccessClientSection4 from "./section4"
import { mediaQueries } from "../../utils/theme/media-queries"
import Container from "../layout/container"
import content from "../../content/agence-amazon/success-client.json"

const Hero = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query SuccessClientQuery {
      Img: file(relativePath: { eq: "successClient.png" }) {
        childImageSharp {
          # Other options include height (set both width and height to crop),
          # grayscale, duotone, rotate, etc.
          fixed(width: 500, height: 320, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)
  //successClient
  const {
    title,
    S1Title,
    S1Subtitle,
    S1Description,
    S2Name,
    S2Position,
    S2Content,
    S3Title,
    S3Paragraph1,
    S3Paragraph2,
    S3Paragraph3,
    S3Paragraph4,
    S3Paragraph5,
    S4Title,
    S4Paragraph1,
    S4Paragraph2,
    S4Paragraph3,
    S4Paragraph2span,
    S4Paragraph3span,
    S4Paragraph3second,
  } = content[langKey]

  return (
    <Container>
      <div
        sx={{
          display: `none`,
          [mediaQueries.lg]: {
            display: `flex`,
            flexDirection: `column`,
            alignItems: `center`,
          },
        }}
      >
        <p
          sx={{
            alignSelf: `center`,
            fontSize: `2.25rem`,
            fontWeight: `900`,
            color: colors.code.secondary,
            marginBottom: `3rem`,
          }}
        >
          {title}
        </p>
        <div sx={{ display: `flex` }}>
          <div sx={{ display: `flex`, flexDirection: `column`, width: `28%` }}>
            <div sx={{ display: `flex` }}>
              <SuccessClientSection1
                title={S1Title}
                subtitle={S1Subtitle}
                description={S1Description}
              />
            </div>
            <div sx={{ display: `flex` }}>
              <div sx={{ display: `flex` }}>
                <Charlotte
                  name={S2Name}
                  position={S2Position}
                  paragraph={S2Content}
                />
              </div>
            </div>
          </div>

          <div
            sx={{
              display: `flex`,
              width: `43%`,
              marginTop: `21rem`,
            }}
          >
            <Img
              alt=""
              fixed={data.Img.childImageSharp.fixed}
              sx={{ marginTop: `-7rem` }}
            />
          </div>
          <div sx={{ display: `flex`, width: `28%`, flexDirection: `column` }}>
            <SuccessClientSection3
              title={S3Title}
              paragraph1={S3Paragraph1}
              paragraph2={S3Paragraph2}
              paragraph3={S3Paragraph3}
              paragraph4={S3Paragraph4}
              paragraph5={S3Paragraph5}
            />

            <SuccessClientSection4
              title={S4Title}
              paragraph1={S4Paragraph1}
              paragraph2={S4Paragraph2}
              paragraph3={S4Paragraph3}
              paragraph2span={S4Paragraph2span}
              paragraph3span={S4Paragraph3span}
              paragraph3second={S4Paragraph3second}
            />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Hero
